$(document).ready(function () {
  var swiperInstances = [];

  function initializeSwiper() {
    $('[data-journal-swiper]').each(function (index, element) {
      var mySwiper = new Swiper(element, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        slidesOffsetBefore: 12,
        clickable: true,
        pagination: {
          el: $(element).next('.swiper-pagination')[0],
          clickable: true,
        },
        breakpoints: {
          500: {
            slidesOffsetBefore: 0,
          },
          900: {
            slidesOffsetBefore: 0,
            slidesPerView: 3,
          },
        },
      });
      swiperInstances.push(mySwiper);
    });
  }

  function destroySwiper() {
    swiperInstances.forEach(function (swiperInstance) {
      swiperInstance.destroy(true, true);
    });
    swiperInstances = [];
  }

  // Initialize Swiper on page load
  initializeSwiper();

  // Reinitialize Swiper on window resize
  $(window).on('resize', function () {
    destroySwiper();
    initializeSwiper();
  });
});

// journal image swiper
$(document).ready(function () {
  var swipers = $(this).find('[data-article-image-swiper]');
  var isTextOnPage = jQuery('.body-text-section, .article__content')[0];

  swipers.each(function () {
    var swiperContainer = $(this);
    // var swiperImages = swiperContainer.find('[data-swiper-image]');

    new Swiper(swiperContainer, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      slidesOffsetBefore: 12,
      centerInsufficientSlides: true,
      updateOnWindowResize: true,
      updateOnImagesReady: true,
      observer: true,
      observeSlideChildren: true,
      watchOverflow: true,
      pagination: {
        el: swiperContainer.find('[data-article-image-swiper-pagination]'),
        clickable: true,
      },
      navigation: {
        nextEl: swiperContainer.find('[data-article-image-swiper-button-next]'),
        prevEl: swiperContainer.find('[data-article-image-swiper-button-prev]'),
      },
      slidesOffsetAfter: 12,
      on: {
        imagesReady: function () {
          updateSwiperContainer(swiperContainer);
        },
        resize: function () {
          updateSwiperContainer(swiperContainer);

          //set first slide to be in line with text on larger viewports
          if (window.innerWidth > 1400 && isTextOnPage) {
            this.params.slidesOffsetBefore =
              window.innerWidth / 2 - $('.page-width--narrow').outerWidth() / 2;
            this.update();
          }
        },
        init: function () {
          //hide pagination if the slides are less than the page width
          if (
            swiperContainer.outerWidth() >=
            swiperContainer.find('.swiper-wrapper').get()[0].scrollWidth
          ) {
            $('.article__image-swiper-pagination').hide();
          }

          //set first slide to be in line with text on larger viewports
          if (window.innerWidth > 1400 && isTextOnPage) {
            this.params.slidesOffsetBefore =
              window.innerWidth / 2 - $('.page-width--narrow').outerWidth() / 2;
            this.update();
          }
        },
      },
    });
  });
});

// journal swiper mobile only (for the journal landing page)
$(document).ready(function () {
  var journalSwiperMobileElm = $('[data-journal-swiper-mobile]');

  var breakpoint = window.matchMedia('(min-width:990px)');
  var mySwiper;

  var breakpointChecker = function () {
    if (breakpoint.matches === true) {
      if (mySwiper !== undefined) mySwiper.destroy(true, true);
      return;
    } else if (breakpoint.matches === false) {
      return enableSwiper();
    }
  };

  var enableSwiper = function () {
    mySwiper = new Swiper('[data-journal-swiper-mobile]', {
      slidesPerView: 'auto',
      spaceBetween: 12,
      slidesOffsetBefore: 12,
      slidesOffsetAfter: 12,
    });
  };

  if (journalSwiperMobileElm) {
    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
  }
});

// journal image swiper layout 2
$(document).ready(function () {
  var swipersLayout2 = $(this).find('[data-article-image-swiper-layout-2]');
  swipersLayout2.each(function () {
    var swiperContainer = $(this);
    new Swiper(swiperContainer, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      centerInsufficientSlides: true,
      updateOnWindowResize: true,
      updateOnImagesReady: true,
      observer: true,
      observeSlideChildren: true,
      watchOverflow: true,
      pagination: {
        el: swiperContainer.find('[data-article-image-swiper-pagination]'),
        clickable: true,
      },
      navigation: {
        nextEl: swiperContainer.find('[data-article-image-swiper-button-next]'),
        prevEl: swiperContainer.find('[data-article-image-swiper-button-prev]'),
      },
      on: {
        imagesReady: function () {
          updateSwiperContainer(swiperContainer);
          this.slideTo(0, 0, false); // this guarantees the first slide is always at position 0
        },
        resize: function () {
          updateSwiperContainer(swiperContainer);
          handleAlignment(swiperContainer);
          handlePagination(swiperContainer);
          this.slideTo(0, 0, false);
        },
        init: function () {
          //hide pagination if the slides are less than the page width
          handleAlignment(swiperContainer);
          handlePagination(swiperContainer);
        },
      },
    });
  });
});

// manually update swiper container on events
// this is needed due to swiper does not manage caption width (it will overflow. However it does manage images' width nicely)
// unresolvable issue with swiper, so manually update swiper slides width
// GitHub issue: https://github.com/nolimits4web/swiper/issues/3399
var updateSwiperContainer = (swiperContainer) => {
  var swiperImages = swiperContainer.find('[data-swiper-image]'); // can we just use .swiper-slide > img instead?
  if (!swiperImages) return;
  swiperImages.each(function () {
    var _this = $(this);
    _this.closest('.swiper-slide').width(_this.width());
  });
};

var handlePagination = (swiperContainer) => {
  var pagination = swiperContainer.find('.swiper-pagination');
  if (pagination) {
    if (
      swiperContainer.outerWidth() < swiperContainer.find('.swiper-wrapper').get()[0].scrollWidth
    ) {
      pagination.show();
    } else {
      pagination.hide();
    }
  }
};

var handleAlignment = (swiperContainer) => {
  var swiperWrapper = swiperContainer.find('.swiper-wrapper').first();
  var alignedLeft = swiperWrapper.hasClass('aligned-left');
  var alignedRight = swiperWrapper.hasClass('aligned-right');
  var isLayout2 = swiperContainer.hasClass('layout-2');

  swiperWrapper.css('justify-content', '');

  // For layout-2, never apply the transform override styles
  if (isLayout2) {
    handleOverRidingStyles(true);
    if (alignedRight && swiperContainer.outerWidth() >= swiperWrapper.get(0).scrollWidth) {
      swiperWrapper.css('justify-content', 'flex-end');
    }
  } else {
    if (swiperContainer.outerWidth() < swiperWrapper.get(0).scrollWidth) {
      swiperWrapper.css('justify-content', '');
      handleOverRidingStyles(true);
    } else {
      if (alignedLeft || alignedRight) {
        handleOverRidingStyles();
        if (alignedRight) {
          swiperWrapper.css('justify-content', 'flex-end');
        }
      }
    }
  }
};

var isStylePresent = () => {
  var styles = document.head.querySelectorAll('style');
  for (var i = 0; i < styles.length; i++) {
    if (
      styles[i].innerHTML.includes('.swiper-wrapper.aligned-left, .swiper-wrapper.aligned-right')
    ) {
      return true;
    }
  }
  return false;
};

var handleOverRidingStyles = (remove = false) => {
  if (remove && isStylePresent()) {
    var styles = document.head.querySelectorAll('style');
    for (var i = 0; i < styles.length; i++) {
      if (
        styles[i].innerHTML.includes('.swiper-wrapper.aligned-left, .swiper-wrapper.aligned-right')
      ) {
        styles[i].remove();
      }
    }
  } else if (!remove && !isStylePresent()) {
    var style = document.createElement('style');
    style.innerHTML = `
      .swiper-wrapper.aligned-left, .swiper-wrapper.aligned-right {
        transform: translateX(0) !important;
      }
      .swiper-wrapper.aligned-right > .swiper-slide:last-child {
        margin-right: 0 !important;
      }
    `;
    document.head.appendChild(style);
  }
};
